<div class="oauth">
  <div class="oauth__card">
    <div class="oauth__card__title">
      {{ "azuresso.Title_Callback" | translate }}
    </div>
    <div class="oauth__card__body">
      <div class="oauth__card__body__text--center">
        <img src="assets/images/azure_ad.svg" class="mb-[30px]" />

        @if (!hasError && !azureError) {
          <div class="oauth__card__body__text">
            {{ "azuresso.Auth_Wait" | translate }}
          </div>
          <app-loader></app-loader>
        }
        @if (hasError) {
          <div class="oauth__card__body__text red-color">
            {{ "azuresso.Auth_Error" | translate }}
          </div>
        }
        @if (azureError) {
          <div class="oauth__card__body__text red-color">
            {{ "azuresso.Azure_Error" | translate }}
          </div>
        }
      </div>
    </div>
  </div>
</div>
